import { cva } from 'cva'

export const stackStyle = cva({
  base: ['flex'],

  variants: {
    direction: {
      horizontal: ['flex-row'],
      vertical: ['flex-col'],
    },
    align: {
      start: ['items-start'],
      center: ['items-center'],
      end: ['items-end'],
      between: ['items-between'],
      around: ['items-around'],
      evenly: ['items-evenly'],
    },
    justify: {
      start: ['justify-start'],
      center: ['justify-center'],
      end: ['justify-end'],
      between: ['justify-between'],
      around: ['justify-around'],
      evenly: ['justify-evenly'],
    },
  },

  defaultVariants: {
    direction: 'horizontal',
  },
})
